import React, { Component, useState, useEffect } from "react";
import styles from "./css/JoinUs.module.css";

import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";
import { ResponseAlert, SnackNotifications } from "../MyMaterialUi";

import { PlusIcon } from "../Svgs";
import ImageUploading from "react-images-uploading";

export const jobsListStore = [
  {
    urlTxt: "carpentry",
    hrefTxt: "Carpentry",
    icon: "/assets/icons/join-us/carpenter.svg",
  },
  {
    urlTxt: "painting",
    hrefTxt: "Painting",
    icon: "/assets/icons/join-us/painting.svg",
  },
  {
    urlTxt: "electrical",
    hrefTxt: "Electrical",
    icon: "/assets/icons/join-us/electrical.svg",
  },
  {
    urlTxt: "plumbing",
    hrefTxt: "Plumbing",
    icon: "/assets/icons/join-us/plumbing.svg",
  },
  {
    urlTxt: "housekeeping",
    hrefTxt: "Housekeeping",
    icon: "/assets/icons/join-us/household.svg",
  },
  {
    urlTxt: "general-contractor",
    hrefTxt: "General Contractor",
    icon: "/assets/icons/join-us/general-contractor.svg",
  },
  {
    urlTxt: "home-builder",
    hrefTxt: "Home Builder",
    icon: "/assets/icons/join-us/home-builder.svg",
  },
  {
    urlTxt: "insulation",
    hrefTxt: "Insulation",
    icon: "/assets/icons/join-us/insulation.svg",
  },
  {
    urlTxt: "landscaping",
    hrefTxt: "Landscaping",
    icon: "/assets/icons/join-us/landscaping.svg",
  },
  {
    urlTxt: "masonry",
    hrefTxt: "Masonry",
    icon: "/assets/icons/join-us/masonry.svg",
  },
  {
    urlTxt: "painting",
    hrefTxt: "Painting",
    icon: "/assets/icons/join-us/painting.svg",
  },
  {
    urlTxt: "plastering",
    hrefTxt: "Plastering",
    icon: "/assets/icons/join-us/plastering.svg",
  },
  {
    urlTxt: "decking",
    hrefTxt: "Decking",
    icon: "/assets/icons/join-us/decking.svg",
  },
  {
    urlTxt: "drywell",
    hrefTxt: "Drywell",
    icon: "/assets/icons/join-us/dry-wall.svg",
  },
  {
    urlTxt: "fencing",
    hrefTxt: "Fencing",
    icon: "/assets/icons/join-us/fencing.svg",
  },
  {
    urlTxt: "flooring",
    hrefTxt: "Flooring",
    icon: "/assets/icons/join-us/flooring.svg",
  },
  {
    urlTxt: "handyman",
    hrefTxt: "Handyman",
    icon: "/assets/icons/join-us/handyman.svg",
  },
  {
    urlTxt: "hvac",
    hrefTxt: "Hvac",
    icon: "/assets/icons/join-us/hvac.svg",
  },
  {
    urlTxt: "renovations",
    hrefTxt: "Renovations",
    icon: "/assets/icons/join-us/renovation.svg",
  },
  {
    urlTxt: "roofing",
    hrefTxt: "Roofing",
    icon: "/assets/icons/join-us/roofing.svg",
  },
  {
    urlTxt: "tiling",
    hrefTxt: "Tiling",
    icon: "/assets/icons/join-us/tiling.svg",
  },
  {
    urlTxt: "windows-doors",
    hrefTxt: "Windows & Doors",
    icon: "/assets/icons/join-us/windows.svg",
  },
];

export class JoinUs extends Component {
  render() {
    return (
      <div className={styles.joinUs}>
        <div className={styles.joinUsInner}>
          <Navbar></Navbar>
          <div className={styles.bodyBlock}>
            <div className={styles.bodyBlockInner}>
              <div className={styles.bodyCover}>
                <div className={styles.coverImage}>
                  <img src="/assets/icons/join-us/new-ilustration/Electrical.svg" />
                </div>
                <div className={styles.headingDescription}>
                  <div className={styles.heading}>
                    <h1>Tell us about what type job you do?</h1>
                  </div>
                  <div className={styles.description}>
                    <p>
                      Welcome to Join Up our pro service Carpentry, Painting,
                      Eletrical, Plumbing, Housekeeping and other service
                    </p>
                  </div>
                </div>
                <div className={styles.coverImage}>
                  <img src="/assets/icons/join-us/new-ilustration/Objects.svg" />
                </div>
              </div>
              <div className={styles.userInformationInputBlock}>
                <ModalToCollectUserData></ModalToCollectUserData>
              </div>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div>
    );
  }
}

const ModalToCollectUserData = (props) => {
  const [noOfModals, setNoOfModals] = useState(6);
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [previousUploadedImages, setPreviosUploadedImages] = useState([]);
  const [myJob, setMyJob] = useState(null);
  const [citiesForMyJob, setCitiesForMyJob] = useState([]);
  const [jobsList, setJobsList] = useState([]);

  useEffect(() => {
    setPreviosUploadedImages([]);
    setMyJob(jobsListStore[0]);
    setJobsList(jobsListStore);
    setCitiesForMyJob([]);
  }, [props]);

  const nextMove = () => {
    if (currentModalIndex < 5) {
      setCurrentModalIndex((currentModalIndex) => currentModalIndex + 1);
    }
  };

  const prevMove = () => {
    if (currentModalIndex > 0) {
      setCurrentModalIndex((currentModalIndex) => currentModalIndex - 1);
    }
  };

  const addCityForJob = (city) => {
    setCitiesForMyJob([...citiesForMyJob, city]);
  };

  const selectJob = (job) => {
    setMyJob(job);
  };

  return (
    <div className={styles.modalCont}>
      <div className={styles.modalBody}>
        <SwitchModalScreen
          currentModalIndex={currentModalIndex}
          previousUploadedImages={previousUploadedImages}
          myJob={myJob}
          citiesForMyJob={citiesForMyJob}
          jobsList={jobsList}
          addCityForJob={addCityForJob}
          selectJob={selectJob}
        ></SwitchModalScreen>
      </div>
      <div className={styles.actionBtns}>
        {currentModalIndex == 0 ? (
          <button className={styles.nextBtn} onClick={() => nextMove()}>
            Join Network
          </button>
        ) : (
          <>
            <button className={styles.prevBtn} onClick={() => prevMove()}>
              Previous
            </button>
            <button className={styles.nextBtn} onClick={() => nextMove()}>
              Next
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const SwitchModalScreen = (props) => {
  if (props.currentModalIndex == 0) {
    return <BusinessDetails></BusinessDetails>;
  } else if (props.currentModalIndex == 1) {
    return <NameAndPhoneNo></NameAndPhoneNo>;
  } else if (props.currentModalIndex == 2) {
    return (
      <TypeOfJob
        jobsList={props.jobsList}
        myJob={props.myJob}
        selectJob={props.selectJob}
      ></TypeOfJob>
    );
  } else if (props.currentModalIndex == 3) {
    return <DescribeYourJob myJob={props.myJob}></DescribeYourJob>;
  } else if (props.currentModalIndex == 4) {
    return (
      <UploadYourImages
        previousUploadedImages={props.previousUploadedImages}
      ></UploadYourImages>
    );
  } else if (props.currentModalIndex == 5) {
    return (
      <CityToReceiveProposals
        citiesForMyJob={props.citiesForMyJob}
        addCityForJob={props.addCityForJob}
      ></CityToReceiveProposals>
    );
  }
};

const BusinessDetails = (props) => {
  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>Please give us your Business details</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Business Address</label>
          </div>
          <div className={styles.input}>
            <input type="text" placeholder="Full  Address" />
          </div>
        </div>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Business Name</label>
          </div>
          <div className={styles.input}>
            <input type="text" placeholder="Business Name" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const NameAndPhoneNo = (props) => {
  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>Your name, email, and phone number</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Name</label>
          </div>
          <div className={styles.input}>
            <input type="text" placeholder="Name" />
          </div>
        </div>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Email</label>
          </div>
          <div className={styles.input}>
            <input type="email" placeholder="Email" />
          </div>
        </div>
        <div className={styles.inputWithLabel}>
          <div className={styles.label}>
            <label>Phone Number</label>
          </div>
          <div className={styles.input}>
            <input type="phone" placeholder="0088-123456789" />
          </div>
        </div>
      </div>
    </div>
  );
};


export const TypeOfJob = (props) => {
  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>Tell us what type the job you do?</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.jobsList}>
          {props.jobsList && props.myJob
            ? props.jobsList.map((job, index) => (
                <div
                  key={index}
                  className={styles.singleJob}
                  onClick={() => props.selectJob(job)}
                >
                  <div className={styles.radioBtnCont}>
                    {props.myJob["hrefTxt"] == job["hrefTxt"] ? (
                      <div className={styles.radioBtn}></div>
                    ) : null}
                  </div>
                  <div>
                    <img src={job["icon"]} />
                  </div>
                  <div>{job["hrefTxt"]}</div>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

const DescribeYourJob = (props) => {
  return props.myJob ? (
    <div>
      <div className={styles.modalHeading}>
        <h3>Describe your job</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.singleJob}>
          <div className={styles.radioBtnCont}>
            <div className={styles.radioBtn}></div>
          </div>
          <div>
            <img src={props.myJob["icon"]} />
          </div>
          <div>{props.myJob["hrefTxt"]}</div>
        </div>
        <textarea
          className={styles.jobDescription}
          placeholder="Describe your work"
        ></textarea>
      </div>
    </div>
  ) : null;
};

export const UploadYourImages = (props) => {
  const [previousUploadedImages, setPreviousUploadedImages] = useState([]);

  const [images, setImages] = React.useState([]);
  const maxNumber = 69;

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  useEffect(() => {
    setPreviousUploadedImages(props.previousUploadedImages);
  }, [props]);

  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>Upload images describe your job</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.uploadYourImages}>
          {previousUploadedImages
            ? previousUploadedImages.map((previousImage, index) => (
                <div className={styles.prevImage} key={index}>
                  <img src={previousImage["src"]} />
                </div>
              ))
            : null}

          {images.map((image, index) => (
            <div className={styles.prevImage} key={index}>
              <img src={image["data_url"]} />
            </div>
          ))}

          <ImageUploading
            multiple
            value={images}
            onChange={onChange}
            maxNumber={maxNumber}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">


            <div className={styles.uploadImage} style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}>
                        <img src="/assets/icons/join-us/upload-image.svg" />
                    </div>


                {/*





                            &nbsp;
            <button onClick={onImageRemoveAll}>Remove all images</button>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button onClick={() => onImageUpdate(index)}>Update</button>
                  <button onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div>
            ))}

                */}
              </div>
            )}
          </ImageUploading>
        </div>
      </div>
    </div>
  );
};

const CityToReceiveProposals = (props) => {
  const [cityName, setCityName] = useState("");
  const [cityZipCode, setCityZipCode] = useState(0);

  const [errorStatus, setErrorStatus] = useState(false);
  const [errors, setErrors] = useState([]);
  const [successStatus, setSuccessStatus] = useState(false);
  const [success, setSuccess] = useState([]);
  const [snackNotification, setSnackNotification] = useState(false);

  const addCityForJob = () => {
    let city = {};

    if (cityName.length < 6) {
      setErrorStatus(true);
      setErrors(["Please enter valid city/town name."]);
      setSnackNotification(true);
      return;
    }

    if (cityZipCode < 999) {
      setErrorStatus(true);
      setErrors(["Please enter valid zip code."]);
      setSnackNotification(true);
      return;
    }

    if (props.citiesForMyJob.length >= 20) {
      setErrorStatus(true);
      setErrors(["Only 20 cities/town are allowed."]);
      setSnackNotification(true);
      return;
    }

    if (props.citiesForMyJob.find((city) => city["name"] == cityName)) {
      setErrorStatus(true);
      setErrors(["This city/town already exits."]);
      setSnackNotification(true);
      return;
    }

    if (props.citiesForMyJob.find((city) => city["zipCode"] == cityZipCode)) {
      setErrorStatus(true);
      setErrors(["This zip code already exits."]);
      setSnackNotification(true);
      return;
    }

    city["name"] = cityName;
    city["zipCode"] = cityZipCode;
    props.addCityForJob(city);
  };

  return (
    <div>
      <div className={styles.modalHeading}>
        <h3>City/town do you want to receive proposal</h3>
      </div>

      <div className={styles.inputFieldsGroup}>
        <div className={styles.addCityBlock}>
          <div className={styles.inputWithLabel}>
            <div className={styles.label}>
              <label>City/Twon</label>
            </div>
            <div className={`${styles.input} ${styles.cityInput}`}>
              <input
                type="text"
                placeholder="City Name"
                onChange={(e) => setCityName(e.target.value)}
                value={cityName}
              />
            </div>
          </div>
          <div className={styles.inputWithLabel}>
            <div className={styles.label}>
              <label>Zip Code</label>
            </div>
            <div className={`${styles.input} ${styles.zipCodeInput}`}>
              <input
                type="number"
                placeholder="55050"
                onChange={(e) => setCityZipCode(e.target.value)}
                value={cityZipCode}
              />
            </div>
          </div>
          <div className={styles.inputWithLabel}>
            <div className={styles.label}>
              <label>&nbsp;</label>
            </div>
            <div className={styles.input}>
              <button
                className={`${styles.nextBtn} ${styles.addCityBtn}`}
                onClick={addCityForJob}
              >
                <PlusIcon /> Add
              </button>
            </div>
          </div>
        </div>
        <div className={styles.citiesList}>
          {props.citiesForMyJob
            ? props.citiesForMyJob.map((city, index) => (
                <div key={index} className={styles.singleJob}>
                  <div className={styles.radioBtnCont}></div>
                  <div>{`${city["name"]}, ${city["zipCode"]}`}</div>
                </div>
              ))
            : null}
        </div>
      </div>
      <SnackNotifications
        open={snackNotification}
        close={() => setSnackNotification(!snackNotification)}
        successStatus={successStatus}
        errorStatus={errorStatus}
        errors={errors}
        success={success}
      ></SnackNotifications>
    </div>
  );
};

export default JoinUs;
